import type { SsoLoginResult, SsoTrialContext } from '@/context/types';

import { reportOpenAiAdsConversion } from './openai-ads-conversions';

// The SSO twin of the `trial_started` report in `handleCreateTrial` (SCRUM-2203). Both SSO endpoints
// apply the trial context only when the login CREATES the account, so a new account plus a context
// that names a config is the front end's best proof that a trial was granted: `custom` is validated by
// the API (an invalid one answers 400, which lands in the error callback and never here), and
// `entry_point` makes the API pick the config itself. A context with neither — a page id alone, or a
// trial modal with no config — creates an account with no trial, so it reports nothing.
// An existing account, a closed Google popup (no `result`) and an error never reach the report.
// Navigation is not this function's business: SSO signups land where any login lands, on purpose
// (PR #1071), so the thanks page is not part of the SSO flow.
export function trackSsoTrialStart(result: SsoLoginResult | undefined, trialContext: SsoTrialContext | null | undefined): void {
  if (!result?.isNewAccount || !trialContext) return;
  const grantsTrial = (trialContext.custom !== null && trialContext.custom !== undefined) || Boolean(trialContext.entry_point);
  if (!grantsTrial) return;
  reportOpenAiAdsConversion({ type: 'trial_started', planId: trialContext.custom ?? null, email: result.email ?? null });
}
